import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./addAdress.css";
import { clearSessionOnCheckout } from "../../compenent/helpers/localstorage";
import { showSpinner } from "../../compenent/helpers/loading";
import axios from "axios";
import { StateContext } from "../../context/ContextProvider";
import { API } from "../../config/api"
import addressimg from "../../assets/images/Address image.png"
import {
  getItemsFromLocalStorage,
  setItemToLocalStorage,
} from "../../utils/localStorageActions";

function AddAdress() {
  const navigate = useNavigate();
  const localstorecart = JSON.parse(localStorage.getItem("cart"));

  const [address, setAddress] = useState(
    getItemsFromLocalStorage("address") || {
      location: "",
      pincode: "",
      flat: "",
      area: "",
    }
  );

  const { location, pincode, area, flat } = address;

  const addressHandler = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  // const [location, setLocation] = useState("");
  // const [pincode, setPincode] = useState("");
  // const [flat, setFlat] = useState("");
  // const [area, setArea] = useState("");

  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { setCart } = useContext(StateContext);



  const handleSubmit = async (e) => {
    e.preventDefault();
    setItemToLocalStorage("address", address);

    let emptObj = [];
    console.log("localstorecart", localstorecart);
    console.log(isSubmitting);
    for (let i = 0; i < localstorecart.length; i++) {
      emptObj.push({
        productId: localstorecart[i]._id,
        quantity: localstorecart[i].count,
        totalPrice: localstorecart[i].itemPrice, 
        productPrice:  localstorecart[i].itemPrice,
        // productPrice:  localstorecart[i].customerPrice,
        offerDiscount: localstorecart[i].discountType,
        totalDiscount : localstorecart[i].customerDiscount
      });
    }

    let subTotal = localstorecart
      .map((product, index) => product?.itemPrice * product?.count)
      .reduce((a, b) => a + b, 0)
      .toFixed(2);

      
      let total = sessionStorage.getItem('price')
      let cartTotalPrice = parseFloat(total).toFixed(0)


    //  (
    //   subTotal -
    //   localstorecart
    //     .map((product, index) => {
    //       if (product?.discountType === "FIXED") {
    //         return parseInt(product?.customerDiscount);
    //       } else {
    //         return (
    //           (parseInt(product?.itemPrice) *
    //             parseInt(product?.count) *
    //             parseInt(product?.customerDiscount)) /
    //           100
    //         );
    //       }
    //     })
    //     .reduce((a, b) => a + b)
    //     .toFixed(0) +
    //   (subTotal * parseFloat(localstorecart[0]?.gst)) / 100 +
    //   0
    // ).toFixed(0);

    // =====================checkout handler====================================
    const myuserId = window.localStorage.getItem("userId");
    const token = localStorage.getItem('token').replace(/^"|"$/g, '')
    const config = { headers: { 
      'X-Token': token,
      // "Content-Type": "application/json"
     } };
    setIsSubmitting(true);
    e.preventDefault();

    const OrderAPI = `${API}/order/add`;
    console.log(localstorecart,"Order API for total GST")

    const payload = {
      userId: myuserId,
      merchantId: localstorecart[0].merchantId,
      distributorId: window.sessionStorage.getItem("distributorId"),
      productDetails: emptObj,
      totalPrice: cartTotalPrice,
      totalGST: sessionStorage.getItem("getGST"),
      city: location,
      address: area,
      pincode: pincode,
      paymentMode: "NOT SELECTED",
      offerDiscount: localstorecart[0].discountType,
      totalDiscount : sessionStorage.getItem("getDis"),
      totalDeliveryCharge: localStorage.getItem('DeliveryRate')
    };
    console.log(payload);
    setLoading(true);
    await axios
      .post(OrderAPI, payload, config)
      .then((res) => {
        const successResponse = res.data.status.toLowerCase() === "success";
        const errorResponse = res.data.status.toLowerCase() === "error";
        console.log("orderdata response", res.data);
        if (successResponse) {
          // setErrMsg(true);
          // setMsg(res?.data?.message || "Your Order  placed successfully");
          // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          setTimeout(() => {
            // setErrMsg(false);

            clearSessionOnCheckout();
            setCart([]);
            setLoading(false);
            navigate("/orderplaced");
          }, 5000);
        } else if (errorResponse) {
          // setErrMsg(true);
          // setMsg(res?.data?.message || "Sorry unable to place your Order");
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }

        //setIsSubmitting(false);
      })
      .catch((err) => {
        console.log("orderdata err", err);
        // setErrMsg(true);
        // setMsg("server error : Sorry unable to send order");
        // setIsSubmitting(false);
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      });
    //changes *******************ended
  };
  return (
    <div className="container-shipping"> {/* container-sm */}
      {/* <div className="row">
        <div className="col-sm-12 "> */}

      {/* <div className="card shipcard"> */}
      {loading && showSpinner()}
      <div className="inner-container-address "> {/*card-body */}
        <div className="Delivery-Address-header">
          <h2>Delivery Address</h2>
        </div>
        <div className="row address-Container borderLess">
          <div className="form-address-contaienr">
            <div className="card mb-4 bs">
              <div className="card-body px-2 pt-0">
                <form
                  style={{
                    width: "100%",
                    backgroundColor: "whitesmoke",
                    //   borderRadius: "25px",
                  }}
                  onSubmit={handleSubmit}
                >
                  <div className="row mb-0 borderLess" style={{background: '#fff'}}>
                    <div className="row borderLess">
                      <div className="form-outline mb-3" id="AddElemet-1">
                        <label className="form-label fomr-lable">
                          DELIVERING ORDER TO*
                        </label>
                        <input
                          type="text"
                          placeholder="Enter a Location"
                          required
                          onChange={addressHandler}
                          name="location"
                          value={location}
                          className="form-control "
                          style={{ height: "2rem", width: "100%" }}
                        ></input>
                      </div>
                    </div>
                    <div className="row borderLess">
                      <div className="form-outline mb-3" id="AddElemet-2">
                        <label className="form-label fomr-lable" id="form-elemet-2">
                          Pincode*
                        </label>
                        <input
                          type="text"
                          placeholder="Pincode"
                          required
                          name="pincode"
                          onChange={addressHandler}
                          className="form-control "
                          style={{ height: "2rem", width: "100%" }}
                          value={pincode}
                          maxLength={6}
                          // pattern="^\d{6}$" 
                        ></input>
                      </div>
                    </div>
                    <div className="row borderLess">
                      <div className="form-otline mb-3" id="AddElemet-3">
                        <label className="form-label fomr-lable">
                          Flot No, Bulding Name*
                        </label>

                        <textarea
                          type="text"
                          placeholder="Flot No, Bulding Name"
                          required
                          name="flat"
                          value={flat}
                          onChange={addressHandler}
                          className="form-control "
                          style={{ height: "5rem", width: "100%" }}
                        ></textarea>
                      </div>
                    </div>
                    <div className="row borderLess">
                      <div className="form outline mb-4" id="AddElemet-4">
                        <label className="form-label fomr-lable">Area/ Locality*</label>

                        <textarea
                          type="text"
                          placeholder="Area/ Locality"
                          required
                          name="area"
                          value={area}
                          onChange={addressHandler}
                          className="form-control  "
                          style={{ height: "5rem",width: "100%" }}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row borderLess">
                    <button
                      type="submit"
                      className="btn btn-color"
                      id="AddElemet-5"
                    >
                      Place order
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-2 mb-4 img-address-contaienr">
            <img src={addressimg} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddAdress;
